import styled from 'styled-components'
import { Link } from 'react-router-dom'

function HomeMissionListItem(props) {

  const Row = styled.div`
    background: #1d2c33;
    color: #f7f5f0;
    padding: 18px 28px;
    display: grid;
    grid-template-columns: 56px 1fr auto;
    gap: 24px;
    align-items: center;
    transition: background 0.2s, padding-left 0.2s;
    cursor: pointer;

    &:hover {
      background: #2a3a42;
      padding-left: 36px;
    }

    @media (max-width: 575px) {
      grid-template-columns: 48px 1fr;
      padding: 14px 18px;

      &:hover {
        padding-left: 22px;
      }
    }
  `;

  const StyledLink = styled(Link)`
    text-decoration: none;
    color: inherit;
    display: block;
  `;

  const Year = styled.div`
    font-family: 'Source Serif 4', Georgia, serif;
    font-weight: 600;
    font-size: 22px;
    color: #c9b897;
    letter-spacing: -0.005em;
    line-height: 1;
  `;

  const Body = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  `;

  const Name = styled.div`
    font-family: 'Source Serif 4', Georgia, serif;
    font-weight: 500;
    font-size: 16px;
    color: #f7f5f0;
    letter-spacing: -0.005em;

    strong {
      font-weight: 700;
      color: #c9b897;
    }
  `;

  const Op = styled.div`
    font-family: 'Rubik', sans-serif;
    font-weight: 300;
    font-size: 13px;
    color: rgba(247, 245, 240, 0.7);
  `;

  const Arrow = styled.div`
    font-family: 'Source Serif 4', Georgia, serif;
    color: #8d7e62;
    font-size: 18px;

    @media (max-width: 575px) {
      display: none;
    }
  `;

  const dt = new Date(props.date);
  const year = dt.getFullYear();

  return (
    <StyledLink to={props.link || '#'}>
      <Row>
        <Year>{year}</Year>
        <Body>
          <Name>Mission <strong>{props.name}</strong></Name>
          <Op>{props.descr}</Op>
        </Body>
        <Arrow>→</Arrow>
      </Row>
    </StyledLink>
  );
}

export default HomeMissionListItem;
